import React, { useState, useEffect } from 'react';
import { fetchData } from '../utils/prismicUtils';
import Loading from '../common/Loading';
import Error from '../common/Error';
import './Feature.css';
import { PrismicRichText } from '@prismicio/react';
import { useIsMobile, useIsTablet } from '../utils/utils';
import FeatureMobile from './FeatureMobile';

export default function Feature({ portfolioNav }) {
  const [ctx, setCtx] = useState({ data: null, loading: true, error: null });
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  useEffect(() => {
    fetchData(setCtx, 'my.portfolio_item.is_feature', true);
  }, []);

  if (ctx.loading) return <Loading />;
  if (!ctx.data || ctx.error) return <Error />;

  const document = ctx.data[0].data;

  return (
    <>
      {isMobile || isTablet ? (
        <FeatureMobile portfolioNav={portfolioNav} />
      ) : (
        <div className="container">
          <div className="left feature-left">
            <div className="feature-badge">Feature</div>
            <h1 className="feature-title">
              <PrismicRichText field={document.title} />
            </h1>
            <a
              className="feature-link"
              target="_blank"
              rel="noreferrer"
              href={document.link_to_article.url}
            >
              Read Now
            </a>
          </div>

          <div className="right">
            {portfolioNav && (
              <div className="portfolio-filter-wrapper">{portfolioNav}</div>
            )}

            <div
              className="feature-photo"
              style={{ backgroundImage: `url(${document.cover_image.url})` }}
            />
          </div>
        </div>
      )}
    </>
  );
}
